import React from 'react';
import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const RecoursOQTFPage = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Header />
      <Box as="main" flex="1">
        <Container maxW="1200px" px={5} py={{ base: 12, lg: 16 }}>
          <VStack align="start" spacing={4}>
            <Heading size="xl">Recours OQTF</Heading>
            <Text color="gray.600">Aide et conseils pour contester une Obligation de Quitter le Territoire Français.</Text>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default RecoursOQTFPage;


